import instance from "../../helpers/Axios.Config";
import fileInstance from "../../helpers/File.Axios.Config";
import paths from "../../Routes/paths";

var url = "canal/";

class CanalAPI {
    static async getAsync(id) {
        try {
            var result = await instance.get(url + `get/${id}`);

            return result;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    static async getListPagedAsync(params) {
        try {
            var result = await instance.get(url + "get-list-paged", { params: params });

            return result;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    static async addAsync(canal) {
        try {
            var result = await instance.post(url + "add", canal);

            return result;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    static async updateAsync(canal) {
        try {
            if(canal.canalSuperiorId <= 0){
                canal.canalSuperiorId = null;
            }
            var result = await instance.post(url + "update", canal);

            return result;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    static async removeAsync(id) {
        try {
            var result = await instance.post(url + `remove/${id}`);

            return result;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    static async getSelectListAsync() {
        try {
          var result = await instance.get(url + "get-select-list");
    
          return result.data.value || [];
    
        } catch (error) {
          console.log(error);
          return undefined;
        }
    }
    
}

export default CanalAPI;